export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_10.c9708263.png";